const LocaleConfig = {
  collection: "languages",
  fields: ["id", "language", "code", "currency", "name"],

  adapter: class Locale {
    constructor(locale) {
      const { code, language, ...otherProps } = locale;
      Object.assign(this, {
        ...otherProps,
        language: code || language
      });
    }

    map(collections, maps) {
      this.currency = maps.currencies[this.currency];
    }
  }
};

export default LocaleConfig;
